import React from 'react';
import { Navigate } from 'react-router-dom';

export default function MyBookings() {
  return <Navigate to="/my-account" replace />;
}
